export const parentMessageTargetOrigin = (search = window.location.search) => {
  const params = new URLSearchParams(search)

  if (params.get('widget') !== '1') {
    return '*'
  }

  try {
    const url = new URL(params.get('widget_source_url') || '')

    return ['http:', 'https:'].includes(url.protocol) ? url.origin : '*'
  } catch (e) {
    return '*'
  }
}

export const notifyParentFormClosed = () => {
  if (typeof window === 'undefined' || window.parent === window) {
    return
  }

  window.parent.postMessage('close-form', parentMessageTargetOrigin())
}
